<div perfectScrollbar class="fade-content" [ngClass]="contentClass" [ngStyle]="{ 'max-height.px': height }">
  <ng-content></ng-content>
</div>
